var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSettingIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.32 8.05l-1.89-.63.89-1.78a1 1 0 0 0-.19-1.14L16 2.37a1 1 0 0 0-1.15-.19l-1.78.89-.63-1.89A1 1 0 0 0 11.5.5h-3a1 1 0 0 0-.95.68l-.63 1.89-1.78-.89A1 1 0 0 0 4 2.37L1.87 4.5a1 1 0 0 0-.19 1.15l.89 1.78-1.89.63A1 1 0 0 0 0 9v3a1 1 0 0 0 .68.95l1.89.63-.89 1.78a1 1 0 0 0 .19 1.14L4 18.63a1 1 0 0 0 1.15.19l1.78-.89.63 1.89a1 1 0 0 0 .95.68h3a1 1 0 0 0 .95-.68l.63-1.89 1.78.89a1 1 0 0 0 1.13-.19l2.13-2.13a1 1 0 0 0 .19-1.15l-.89-1.78 1.89-.63A1 1 0 0 0 20 12V9a1 1 0 0 0-.68-.95zM18 11.28l-1.2.4a2 2 0 0 0-1.16 2.82l.57 1.14-1.1 1.1-1.11-.6a2 2 0 0 0-2.79 1.16l-.4 1.2H9.22l-.4-1.2A2 2 0 0 0 6 16.14l-1.14.57-1.1-1.1.6-1.11a2 2 0 0 0-1.16-2.82l-1.2-.4V9.72l1.2-.4A2 2 0 0 0 4.36 6.5l-.57-1.11 1.1-1.1L6 4.86A2 2 0 0 0 8.82 3.7l.4-1.2h1.56l.4 1.2A2 2 0 0 0 14 4.86l1.14-.57 1.1 1.1-.6 1.11a2 2 0 0 0 1.16 2.79l1.2.4v1.59zM10 6.5a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4z",
    fill: "#6B47F5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSettingIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/settingIcon.cf373c9d.svg";
export { ForwardRef as ReactComponent };